export default __webpack_public_path__ + "b04f3b84d4b4dbc4dd26ae189b0a2300.png";